import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const KeepInMindIcon = ({
  width = "11",
  height = "10",
  style,
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} style={style}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 11 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.33333 0H-9.53674e-07L3.66667 4.5H11L7.33333 0Z"
          fill="#FE8836"
        />
        <path
          d="M7.33333 10H-9.53674e-07L3.66667 5.5H11L7.33333 10Z"
          fill="#024760"
        />
      </svg>
    </IconWrapper>
  );
};
